module.exports = {
      id: "fallback-image-usage",
      viewBox: "0 0 102 76",
      url: __webpack_public_path__ + "svg-sprite-e76c2ea32079628f8a8c5156f1fd5f59.svg#fallback-image",
      toString: function () {
        return this.url;
      }
    }